import type { AxiosError } from 'axios';

import { type QueryClientConfig } from '@tanstack/react-query';

const MAX_RETRY_COUNT = 3;

const RETRYABLE_ERROR_CODE = 'ERR_NETWORK';

function isRetryableError(error: unknown): boolean {
  const axiosError = error as AxiosError | undefined;
  const status = axiosError?.response?.status;

  if (status === undefined) {
    return axiosError?.code === RETRYABLE_ERROR_CODE;
  }

  return status >= 500;
}

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount: number, error): boolean =>
        failureCount < MAX_RETRY_COUNT && isRetryableError(error),
    },
    mutations: {
      retry: false,
    },
  },
};
